// Reine Zeitformatierung fuer den Impersonation-Countdown. KEINE Vue/DOM-Abhaengigkeit,
// damit node:test sie direkt laden kann (Muster wie decideRoute.js).
// ms <= 0 -> "00:00". Sonst "mm:ss", auf ganze Sekunden abgerundet.
function formatRemaining(ms) {
  if (!(ms > 0)) return '00:00';
  const totalSec = Math.floor(ms / 1000);
  const min = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  const pad = (n) => String(n).padStart(2, '0');
  return pad(min) + ':' + pad(sec);
}

module.exports = { formatRemaining };
